module.exports = __webpack_public_path__ + "img/html-evolution-1.9e0ab6c0.webp";